import React from "react";
import classnames from "classnames";
import { Wrap, Paragraph, Numbers } from "./styles";
import { selectedBreakfastsCounter, selectedEntreesCounter } from "./../../../utils/functions";

function SummCounter({ selectedMeals, limitations, dietType, main_title }) {
  const breakfastMinLimitation = limitations.breakfastsMinLimit + limitations.additionalMealsMinLimit.breakfastsMinLimit;
  const entreesMinLimitation = limitations.entreesMinLimit + limitations.additionalMealsMinLimit.entreesMinLimit;
  const selectedBreakfasts = selectedBreakfastsCounter(selectedMeals);
  const selectedEntrees = selectedEntreesCounter(selectedMeals);
  const _mealType = typeof main_title !== "undefined" ? main_title : dietType;
  const overallLimitations = breakfastMinLimitation + entreesMinLimitation;

  if (overallLimitations === 0) {
    return (
      <Wrap>
        <Paragraph>
          Breakfasts
          <Numbers>
            <b className="simple">{selectedBreakfasts}</b>
          </Numbers>
        </Paragraph>
        <Paragraph>
          Entrées
          <Numbers>
            <b className="simple">{selectedEntrees}</b>
          </Numbers>
        </Paragraph>
      </Wrap>
    );
  }

  return (
    <Wrap>
      {breakfastMinLimitation > 0 && (_mealType !== "Mediterranean Plan" && _mealType !== "Diabetes Plan" && _mealType !== "Heart-Friendly Plan") && (
        <Paragraph>
          Choose <b>{breakfastMinLimitation}</b> Breakfasts
          <Numbers>
            <b className={classnames({ active: selectedBreakfasts >= breakfastMinLimitation })}>{selectedBreakfasts}</b> <span>of</span>{" "}
            {breakfastMinLimitation}
          </Numbers>
        </Paragraph>
      )}
      {breakfastMinLimitation === 0 && entreesMinLimitation > 0 && (_mealType !== "Mediterranean Plan"  && _mealType !== "Diabetes Plan" && _mealType !== "Heart-Friendly Plan") && (
        <Paragraph>
          Choose Breakfasts (optional)
          <Numbers>{selectedBreakfasts}</Numbers>
        </Paragraph>
      )}
      {entreesMinLimitation > 0 && (
        <Paragraph>
          Choose <b>{entreesMinLimitation}</b> Entrées
          <Numbers>
            <b className={classnames({ active: selectedEntrees >= entreesMinLimitation })}>{selectedEntrees}</b> <span>of</span>{" "}
            {entreesMinLimitation}
          </Numbers>
        </Paragraph>
      )}
      {entreesMinLimitation === 0 && breakfastMinLimitation > 0 && (
        <Paragraph>
          Choose Entrées (optional)
          <Numbers>{selectedEntrees}</Numbers>
        </Paragraph>
      )}
    </Wrap>
  );
}

export default SummCounter;
